<template lang="pug">
  #ProductCard.p-3.is-flex.is-flex-direction-column.is-justify-content-space-between.is-align-items-center
    section.product-card-body.mb-2.is-flex.is-flex-direction-column.is-align-items-center
      WtTitle.is-align-self-flex-start(h3) Your Plan
      WtTitle.is-align-self-flex-start(h4)
        span.pr-1 {{ tbyProductName }}

      template
        .product-details
          template(v-for="detail in productDetails")
            .level.level-is-shrinkable.is-mobile.mb-half
              .level-left
                .level-item
                  BIcon(icon="check-circle"  type="is-primary")
                .level-item
                  .is-size-7-half {{ detail }}
</template>

<script>
import { numberUtilityMixin } from "@/mixins/numberUtilityMixin";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
export default {
  name: "ProductCard",

  components: { WtTitle, WtButton },

  mixins: [numberUtilityMixin],

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      bewellcoreDetails: [
        "Track steps and seamlessly convert activities.",
        "Run activity challenges on themed, virtual maps.",
        "Boost engagement with built-in social and communication tools.",
        "Uncover meaningful insights with easy-to-use reporting tools."
      ],
      bewellplusDetails: [
        "Track steps, activities and wellness metrics like sleep, nutrition, mindfulness and more.",
        "Run themed Activity and Wellness challenges.",
        "Boost engagement with teams and built-in social tools.",
        "Uncover meaningful insights with easy-to-use reporting tools."
      ],
      bewellproDetails: [
        "Track steps, activities and wellness metrics like sleep, nutrition, mindfulness and more.",
        "Run themed Activity and Wellness challenges.",
        "Boost engagement with teams and built-in social tools.",
        "Uncover meaningful insights with easy-to-use reporting tools."
      ]
    };
  },

  computed: {
    productDetails() {
      switch (this.product.name) {
        case "BeWellCore":
          return this.bewellproDetails;
        case "BeWellPlus":
          return this.bewellplusDetails;
        case "BeWellPro":
          return this.bewellcoreDetails;
        default:
          return this.bewellcoreDetails;
      }
    },

    tbyProductName() {
      switch (this.product.name) {
        case "BeWellCore":
          return "BeWell-Core";
        case "BeWellPlus":
          return "BeWell-Plus";
        case "BeWellPro":
          return "BeWell-Pro";
        default:
          return "BeWell-Core";
      }
    }
  }
};
</script>

<style lang="sass">
#ProductCard
  height: 98%
  border-radius: $radius-large
  // box-shadow: 0px 0px 15px .5px $grey-light
  +desktop
    // max-width: 275px
  .product-card-body
    min-height: 60%
  .product-details
    .is-size-8-half
      font-size: .85rem
  .mb-half
    margin-bottom: .5rem
  .icon
    -webkit-transition: -webkit-transform .4s linear
            transition:         transform .4s linear
  .icon:hover
    -webkit-transform: rotate(360deg)
            transform: rotate(360deg)
</style>
